import React, { Suspense } from "react";
import TestHeaderInfo from "./testHeaderInfo";
import TestParametersList from "./testParametersList";
import TestInfo from "./testInfo";
import FaqList from "./faqList";

// const TestInfo = React.lazy(() => import("./testInfo"));
// const FaqList = React.lazy(() => import("./faqList"));

const TestDetails = ({
    testDetails,
    selectedTest,
    testVariantDetails,
    ISLOGGEDIN,
    currentType,
}) => {
    return (
        <>
            <div className="w-full min-w-0 md:flex-1 flex flex-col gap-5 md:gap-6">
                <TestHeaderInfo
                    testDetails={testDetails}
                    testVariantDetails={testVariantDetails}
                    selectedTest={selectedTest}
                    currentType={currentType}
                    ISLOGGEDIN={ISLOGGEDIN}
                />

                <TestParametersList
                    testParameters={testVariantDetails}
                    isLoading={false}
                />

                {/* We'll lazy-load the TestInfo and FaqList components 
            since they might not be immediately necessary when the 
            component mounts. We'll wrap them with React.Suspense 
            to handle the loading state. */}

                <Suspense fallback={<div>Loading Test Info...</div>}>
                    <TestInfo
                        testDetails={testDetails}
                        testVariantDetails={testVariantDetails}
                        isLoading={false}
                    />
                </Suspense>

                {testVariantDetails?.faqData.length > 0 && (
                    <Suspense fallback={<div>Loading FAQs...</div>}>
                        <FaqList faqData={testVariantDetails?.faqData} />
                    </Suspense>
                )}
            </div>
        </>
    );
};

export default React.memo(TestDetails);
